import { defineStore } from "pinia";
import Record from "@/recorder/recorder-sdk.js";
import { ApiUploadAllVoice } from "@/service/apis/homework";
import { ApiUploadChallengeVoice } from "../../service/apis/challenge";
import { ApiDailySpeechUploadVoice } from "@/service/apis/dailyAispeech";
import {
  ApiPostBookRecording,
  ApiDeleteStdRecording,
} from "@/service/apis/book";
import {
  ApiPostLCRecord,
  ApiGetLCUserLevel,
} from "../../service/apis/levelCheck";
import { compileScript } from "vue/compiler-sfc";
import { Howl } from "howler";
import { useGlobalStore } from "@/store/modules/global.js";
export const useRecordingStore = defineStore("recording", {
  state: () => {
    return {
      recorder: new Record(),
      numberOfQuestions: 5,
      recorderIndex: 0,
      setence: {},
      recordFail: false,
      recordSuccess: false,
      recordStatus: null,
      startRecording: false,
      recordList: [],
      sampleAudio: null,
      audio: new Audio(),
      playStatus: false,
      typeid: "",
      rid: "",
      sentenceList: [],
      playDemoStatus: false,
    };
  },
  actions: {
    resetRecordList() {
      this.recordList = [];
    },
    async uploadLevelCheckRecord(sentence) {
      console.log("uploadLevelCheckRecord sentence = ", sentence);
      let obj = {};
      let formdata = new FormData();
      this.recordList.forEach((item, i) => {
        console.log(item);
        formdata.append("audio", item, sentence + i + ".wav");
        formdata.append("sentence", sentence);
        console.log("formdata = ", formdata);
        // obj.audio = formdata;
      });

      let result = await ApiPostLCRecord.post(formdata);
      if (result.status === "success") {
        this.recordStatus = null;
        return result;
      }
    },
    async uploadChallengeVoice(tid) {
      let obj = {};
      let formdata = new FormData();
      console.log(this.recordList);
      this.recordList.forEach((item, i) => {
        console.log(item);
        formdata.append("audio", item, tid + ".wav");
        console.log("formdata = ", formdata);
        obj.audio = formdata;
      });
      console.log(obj);
      let result = await ApiUploadChallengeVoice.post(tid, obj.audio);
      console.log("uploadChallengeVoice", result);
      return result;
    },
    async uploadDailySpeechVoice(contentId) {
      let obj = {};
      let formdata = new FormData();
      console.log(this.recordList);
      this.recordList.forEach((item, i) => {
        console.log(item);
        formdata.append("audio", item, contentId + ".wav");
        console.log("formdata = ", formdata);
        obj.audio = formdata;
      });
      console.log(obj);
      let result = await ApiDailySpeechUploadVoice.post(contentId, obj.audio);
      console.log("uploadDailySpeechVoice", result);
      return result;
    },
    async uploadAllAsgVoice() {
      // var formdata = new FormData();
      // formdata.append("audio", this.sentence[0].voice_record, "stuVoice.wav");
      let tempList = [];
      this.recordList.forEach((item, i) => {
        let obj = {};
        let formdata = new FormData();

        formdata.append(
          "audio",
          item,
          this.sentenceList[i].sentenceID + ".wav"
        );
        obj.url = `/assignment/voice/${this.typeid}/${this.sentenceList[i].sentenceID}`;
        obj.audio = formdata;
        console.log(obj.audio);
        tempList.push(obj);
      });
      let result = await ApiUploadAllVoice.post(tempList);
      console.log("=====upload all asg voice result======");
      console.log(result);
      return result;
    },
    async uploadReadingRecording() {
      let obj = {};
      let formdata = new FormData();
      console.log(this.recordList);
      this.recordList.forEach((item, i) => {
        console.log(item);
        formdata.append("audio", item, this.rid + ".wav");
        console.log("formdata = ", formdata);
        obj.audio = formdata;
      });
      console.log(obj);
      let result = await ApiPostBookRecording.post(this.rid, obj.audio);
      console.log("=====upload all asg voice result======");
      console.log(result);
      return result;
    },
    addIndex() {
      if (this.recorderIndex + 1 < this.numberOfQuestions) {
        this.recorderIndex = this.recorderIndex + 1;
      }
    },
    minusIndex() {
      if (this.recorderIndex > 0) {
        this.recorderIndex = this.recorderIndex - 1;
      }
    },
    startRecording() {
      this.recorder = new Record();
      this.recorder.clear();
      this.recordStatus = "start";
      this.recorder.startRecord({
        success: (res) => {
          console.log("success", res);
        },
        error: (e) => {
          console.warn(e);
        },
      });
    },
    stopRecording(action) {
      console.log("stoppppp play recording");
      const call = useRecordingStore();
      this.recordStatus = "end";
      this.recorder.stopRecord({
        success: (res) => {
          console.log("success", res);
          this.recordList[this.recorderIndex] = res;
        },
        error: (e) => {
          console.warn(e);
        },
      });
      // Bookreading
      if (action === "uploadReading") {
        call.uploadReadingRecording();
      }
    },
    pushRecording(url) {
      console.log("save url = ", url);
      this.recordList[this.recorderIndex] = url;
      this.recordStatus = "end";
    },
    playRecording() {
      const call = useRecordingStore();

      this.playStatus = true;
      console.log(this.recordList[this.recorderIndex]);
      let audioUrl = URL.createObjectURL(this.recordList[this.recorderIndex]);
      // this.audio = new Audio(audioUrl);
      console.log(audioUrl);
      this.audio = new Howl({
        src: audioUrl,
        html5: true,
        onend: () => {
          call.stopPlayRecording();
        },
      });
      console.log(this.audio);
      this.audio.play();
      // console.log(call);
      // this.audio.on("end", call.stopPlayRecording());
      // this.audio.onended = function () {
      //   call.stopPlayRecording();
      // };
    },
    pausePlayRecording() {
      console.log("play pause");
      this.playStatus = false;
      this.audio.pause();
    },
    stopPlayRecording() {
      console.log("play end");
      this.playStatus = false;
      this.audio.pause();
      this.audio.currentTime = 0;
    },
    async delRecording(myrid) {
      console.log("del recording");
      this.recorder.clear();
      let result = await ApiDeleteStdRecording.get(myrid);
      const global = useGlobalStore();
      if (result.status === "success") {
        this.recordStatus = null;
        this.recordList = [];
        global.$patch((state) => {
          state.alert.show = true;
          state.alert.message = "Deleted the recording successfully";
          state.alert.status = "success";
          setTimeout(() => {
            state.alert.show = false;
          }, 4000);
        });
      }
      return result;
    },
  },
  getters: {
    allFinished: (state) => {
      return state.recordList.length === state.numberOfQuestions;
    },
  },
});
